import { Component, OnInit, ElementRef, Inject, OnDestroy } from '@angular/core';
import { QbCustomer } from 'projects/app-misc/src/app/modules/customer/data/qb-customer';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { CustomerService } from 'projects/app-misc/src/app/modules/customer/data/customer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Customer } from 'projects/app-misc/src/app/modules/customer/data/customer';

@Component({
    selector: 'app-qb-customer-link-dialog',
    templateUrl: './qb-customer-link-dialog.component.html',
    styleUrls: ['./qb-customer-link-dialog.component.scss']
})
export class QbCustomerLinkDialogComponent implements OnInit, OnDestroy {
    allCustomers: QbCustomer[];
    qbCustomers: QbCustomer[];
    selectedQbCustomer: QbCustomer;

    searchString: string;
    customerId: number;

    loadingSpinner = false;

    barSubj: Subscription;
    qbLoading: boolean;

    constructor(
        protected customerService: CustomerService,
        protected dialogRef: MatDialogRef<QbCustomerLinkDialogComponent>,
        protected dialog: MatDialog,
        private snackBar: MatSnackBar,
        protected el: ElementRef,
        @Inject(MAT_DIALOG_DATA) public data: {
            customerName: string,
            customerId: number,
            qbId: string
        }
    ) {
        this.customerId = data.customerId;
    }

    ngOnInit(): void {
        this.qbLoading = true;

        this.customerService.getQBCustomers()
            .subscribe(searchResult => {
                this.qbCustomers = searchResult;
                this.allCustomers = [...this.qbCustomers];

                if (this.data.qbId) {
                    const fqb = this.qbCustomers.find(qb => qb.id === this.data.qbId);
                    if (fqb) this.selectedQbCustomer = fqb;

                    const highlighted = (this.el.nativeElement as HTMLElement).getElementsByClassName('p-highlight');
                    if (highlighted) {
                        timer(1).subscribe(emit => {
                            if (highlighted[0]) {
                                highlighted[0].scrollIntoView({ block: 'center', behavior: 'auto' })
                            }
                        })
                    }
                }

                this.qbLoading = false;

                this.dropDownIsShown();

                if (this.data.customerName && !this.data.qbId) {
                    this.searchString = this.data.customerName;
                    const custName = this.data.customerName.toLowerCase().trim()

                    this.qbCustomers = this.allCustomers.filter(customer => {
                        const name = customer.displayName.toLowerCase().trim();
                        return name.includes(custName);
                    });
                }

            })

    }

    dropDownIsShown() {
        const elems = (this.el.nativeElement as HTMLElement).getElementsByClassName('p-list-box-block');

        timer(1).subscribe(emit => {
            const inputs = elems[0].getElementsByClassName('p-inputtext')

            inputs[0].addEventListener('keyup', eventtt => {
                const val = (inputs[0] as HTMLInputElement).value.toLowerCase();

                if (val) {
                    this.qbCustomers = this.allCustomers.filter(customer => {
                        const name = customer.displayName.toLowerCase();
                        return name.includes(val)
                    });
                }
                else {
                    this.qbCustomers = this.allCustomers
                }

            });
        })
    }


    linkQb() {
        this.loadingSpinner = true;
        this.customerService.saveCustomer({
            id: this.customerId,
            qbId: this.selectedQbCustomer.id,
            qbDisplayName: this.selectedQbCustomer.displayName
        }).subscribe(customer => {
            this.dialogRef.close(customer);
        }, error => {
      this.openSnackBar(error.message)
        })
    }

    openSnackBar(message: string) {
        this.snackBar.open(message, '', {
            duration: 7000,
            verticalPosition: 'top',
            panelClass: 'error-snackbar',
        });
    }


    closeDialog() {
        this.dialogRef.close('close-button');
    }

    ngOnDestroy() {

    }

}
